import { render } from "./Footer.vue?vue&type=template&id=af707c14&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=af707c14&scoped=true&lang=css"

import exportComponent from "/Volumes/DEXP W500C/homePc/актуально/new-dff/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af707c14"]])

export default __exports__